/**
 * PlatformGate — the elevated gate for platform scope (agency-level
 * surfaces). Shares the one isElevatedRole predicate (lib/roles.ts) with
 * the navigation `elevated` gate, AdminPage, and adsToolsAccess.
 * ProtectedRoute blocks rendering until the profile is fetched, so elevated
 * users never see a flash of the empty state.
 *
 * Non-elevated direct visits get the honest empty state (one line, from
 * copyTokens) — not a silent redirect away, and never the data.
 */

import type { ReactNode } from 'react';
import { useWorkspaceStore } from '@/stores/useWorkspaceStore';
import { isElevatedRole } from '@/lib/roles';
import { COPY } from '@/lib/copyTokens';

export function PlatformGate({ children }: { children: ReactNode }) {
  const userProfile = useWorkspaceStore((s) => s.userProfile);

  if (!isElevatedRole(userProfile?.platform_role)) {
    return (
      <div className="mx-auto max-w-2xl px-4 py-16 text-center">
        <p className="text-sm text-ink-2">{COPY.platformEmpty}</p>
      </div>
    );
  }

  return <>{children}</>;
}
